import React, { useState, useEffect } from 'react';
import SmsWidget from '../../../Components/SmsWidget';
import CustomToggle from '../../../Components/Inputs/CustomToggle';
import { CHANNELS } from '../Utils/constants';
import { useAtomValue } from 'jotai';
import { themeAtom } from '../../../Atoms';

const SmsAfterCallWrapper = function SmsAfterCallWrapper({
  customerId,
  setEndCallMessage,
  selectedBranch,
  isEmailAddressAvailable,
  customMessage = false,
  sendEndCallMessage = false,
  activityId = '',
  templates = [],
  checkSubmit = () => {},
  failedChecks = [],
}) {
  const currentTheme = useAtomValue(themeAtom);
  const [selectedTemplate, setSelectedTemplate] = useState(
    customMessage ? 99 : null
  );
  const [channelValue, setChannelValue] = useState('SMS');
  const [contentSms, setContentSms] = useState('');
  const [contentEmail, setContentEmail] = useState('');

  useEffect(() => {
    if (sendEndCallMessage && selectedTemplate !== null) {
      setEndCallMessage({
        templateId: templates[selectedTemplate]?.smsId || null,
        activityId,
        branchId: selectedBranch.id,
        recipients: [customerId],
        emailSubject: templates[selectedTemplate]?.emailSubject,
        emailBody: contentEmail?.replaceAll('§', ''),
        message: contentSms?.replaceAll('§', ''),
        channel: channelValue,
      });
    }
  }, [sendEndCallMessage]);

  const handleChangeChannel = (event, newValue) => {
    setChannelValue(newValue);
  };

  const handleSelectTemplate = (event, newTemplate) => {
    if (newTemplate !== null && newTemplate !== selectedTemplate)
      setSelectedTemplate(newTemplate);
  };

  useEffect(() => {
    setSelectedTemplate(null);
  }, [channelValue]);

  useEffect(() => {
    setContentSms(templates[selectedTemplate]?.contentSMS);
    setContentEmail(templates[selectedTemplate]?.contentEmail);
  }, [selectedTemplate]);

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
      }}
    >
      <CustomToggle
        backgroundColor={currentTheme === 'dark' ? 'greys.darker' : '#ededed'}
        tabs={
          isEmailAddressAvailable
            ? CHANNELS
            : [
                {
                  id: 'SMS',
                  label: 'SMS',
                },
              ]
        }
        handleChange={handleChangeChannel}
        value={channelValue}
        width={isEmailAddressAvailable ? '100%' : '30%'}
      />
      <SmsWidget
        customMessage={customMessage}
        channel={channelValue}
        templates={templates}
        selectedTemplate={selectedTemplate}
        handleChangeTemplate={handleSelectTemplate}
        checkSubmit={checkSubmit}
        setContentSms={setContentSms}
        setContentEmail={setContentEmail}
        failedChecks={failedChecks}
      />
    </div>
  );
};

export default SmsAfterCallWrapper;
